import React from 'react'
import Fade from 'react-reveal/Fade'

const Five = props => (
  <section id="five" className="wrapper style2 special fade inactive">
    <Fade duration={2500}>
      <div className="container">
        <header>
          <h2>Book an artist</h2>
          <p>Send us an email and we'll get back to you with a price quote.</p>
           <div>
  <a
    href="mailto:saraimanarts@gmail.com?subject=Booking%20inquiry"
    className="button primary"
  >
    Book now
  </a>
</div>
        </header>
          <div className="row gtr-uniform gtr-50">

            <div className="col-2 col-8-xsmall">
  
            </div>
            <div className="col-8 col-12-xsmall"></div>
          </div>
      </div>
    </Fade>
  </section>
)
export default Five
